<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditGreyListEntryDialog(true)"
      >新增灰名单项</el-button
    >
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-download"
      @click="onClickExprotBtn()"
      >导出</el-button
    >

    <div @keyup.enter="onClickQueryBtn()">
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        size="mini"
        style="margin-top: 30px"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio :label="1">全量</el-radio>
            <el-radio :label="2">按UID</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注中包含文本：" v-if="form.queryType == 1">
          <el-input
            v-model="form.textInRemark"
            clearable
            style="width: 250px"
          ></el-input>
          （遵循<a
            target="_blank"
            href="https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Guide/Regular_expressions#%E7%BC%96%E5%86%99%E4%B8%80%E4%B8%AA%E6%AD%A3%E5%88%99%E8%A1%A8%E8%BE%BE%E5%BC%8F%E7%9A%84%E6%A8%A1%E5%BC%8F"
            style="color: blue"
            >JavaScript正则表达式格式</a
          >）
        </el-form-item>
        <el-form-item label="UID：" v-if="form.queryType == 2">
          <el-input
            v-model="form.uid"
            clearable
            style="width: 172px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="greyListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="greyListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 601px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="140" />
      <el-table-column prop="remark" label="备注" align="center" width="250" />
      <el-table-column label="UID" align="center" width="90">
        <template slot-scope="scope">
          <span>
            <a
              style="text-decoration: none"
              href="javascript:;"
              @click="toRouterPlayerInfoPage(scope.row)"
            >
              {{ scope.row.uid }}</a
            ></span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="onClickDeleteGreyListBtn(scope.row.uid, scope.row.module)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改灰名单项”对话框 -->
    <EditGreyListEntryDialog
      v-if="shouldEditGreyListEntryDialogVisible"
      @close="onEditGreyListEntryDialogClosed()"
      :value="valueForEditGreyListEntryDialog"
    ></EditGreyListEntryDialog>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("@/util");
import bizutil from "@/bizutil";
const fileDownload = require("js-file-download");
const luxon = require("luxon");
import store from "@/store";

import EditGreyListEntryDialog from "./dialog/EditGreyListEntryDialog";

export default {
  data() {
    return {
      shouldEditGreyListEntryDialogVisible: false, // “添加/修改灰名单项”对话框是否应该显示出来
      valueForEditGreyListEntryDialog: null, // 要传递给“添加/修改灰名单项”对话框的数据
      greyListTableData: [], // 灰名单列表里展示的数据
      form: {
        queryType: 1, // 查询方式（1-全量查询 2-根据uid查询）
        uid: "",
        textInRemark: "", // 备注里得包含的文本
      },
    };
  },

  created() {
    // 传入uid 进行查询
    let uid = this.$route.query.uid;
    if (uid != null) {
      this.form.queryType = 2;
      this.form.uid = uid;
      this.loadGreyList(0, 10);
      return;
    }
  },

  components: {
    EditGreyListEntryDialog,
  },

  methods: {
    loadMore() {
      this.loadGreyList(this.greyListTableData.length, 20);
    },

    /**
     * 跳转到玩家详情界面
     * @param {*} entry
     */
    toRouterPlayerInfoPage(entry) {
      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: { uid: entry.uid, tab: "playerList" },
        }).href,
        "_blank"
      );
    },

    /**
     * 点击了灰名单项的删除按钮
     * @param {*} uid
     * @param {*} module
     */
    onClickDeleteGreyListBtn(uid, module) {
      this.$confirm("此操作将删除该灰名单项，是否继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteGreyListEntry(uid, module);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    /**
     * 查询灰名单
     */
    async loadGreyList(skip, limit) {
      switch (this.form.queryType) {
        case 1: {
          // 全量查

          // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
          if (skip == 0) {
            this.greyListTableData = [];
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/admin/getGreyList`,
              {
                textInRemark: this.form.textInRemark.trim(),
                skip: skip,
                limit: limit,
              },
              {
                headers: {
                  token: bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.greyLists || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              uid: e.uid,
              remark: e.remark,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.greyListTableData = this.greyListTableData.concat(list);

          break;
        }
        case 2: {
          // 根据uid查

          let uid = parseInt(this.form.uid);
          if (isNaN(uid) || uid <= 0) {
            this.$message({
              message: "请填入正确的UID",
              type: "error",
            });
            return;
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/admin/findOneGreyList`,
              {
                uid: uid,
              },
              {
                headers: {
                  token: bizutil.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.greyLists || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              uid: e.uid,
              remark: e.remark,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.greyListTableData = list;

          break;
        }
      }
    },

    /**
     * 删除一个灰名单项
     */
    async deleteGreyListEntry(uid, module) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/deleteGreyList`,
          {
            uidList: [uid],
            module: module,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }
      this.$alert("操作成功（预计几秒钟后生效）", "提示", {
        center: true,
        type: "success",
        callback: (action) => {
          setTimeout(() => {
            this.loadGreyList(0, 20);
          }, 1000);
        },
      });
    },

    /**
     * 打开“添加/修改灰名单项”对话框
     */
    async openEditGreyListEntryDialog(isCreate, oldData) {
      this.shouldEditGreyListEntryDialogVisible = true;
      this.valueForEditGreyListEntryDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改灰名单项”对话框关闭了
     */
    async onEditGreyListEntryDialogClosed() {
      this.shouldEditGreyListEntryDialogVisible = false;
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadGreyList(0, 20);
    },

    /**
     * 点击导出按钮
     */
    async onClickExprotBtn() {
      let resData = (
        await axios.get(`${util.getBackendApiBase()}/v1/admin/exportGreyList`, {
          headers: {
            token: bizutil.getLoginUserToken(),
          },
          responseType: "blob",
        })
      ).data;
      fileDownload(
        resData,
        `${store.projectInfo.name}_灰名单_${luxon.DateTime.now().toFormat(
          "yyyyMMddHHmmss"
        )}.xlsx`
      );
    },
  },
};
</script>